<template>
    <div>
        <div class="row">
            <div class="col-xl-8">
                <reduction_timer
                    :timeStart="reduction.date_from"
                    :timeEnd="reduction.date_to"
                    :serverNow="reduction.srv_time"
                    title="Редукціон"
                    @force-update="forceTenderUpdate"
                />
                
                <reduction_description></reduction_description>
                
                <div id="panel-binds" class="panel" v-if="is_admin || is_comerc">
                    <div   class="panel-hdr bg-primary-700 bg-success-gradient">
                        <h2>Ставки</h2>
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    
                    <div class="panel-container collapse show overflow-auto">
                        <div class="panel-content">
                            <bind_reduction_positions ></bind_reduction_positions>
                        </div>
                    </div>
                </div>
                
                
                <div v-if="!is_comerc || is_admin" id="panel-position" class="panel">
                    <div   class="panel-hdr bg-primary-700 bg-success-gradient">
                        <h2>
                            Редукціон № {{reduction.number}}
                        </h2>
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    <div class="panel-container collapse show overflow-auto">
                        
                        <div class="panel-content">
                            <positions></positions>
                        </div>
                    </div>
                </div>
                
                
            </div>
            
            
            <div class="col-xl-4">
                <reduction_users :user_role="user_role" v-if="is_comerc"></reduction_users>
                <reduction_info></reduction_info>
                <tender_files :tender="reduction"></tender_files>
            </div>
        </div>
    </div>
</template>

<script>

import socketMixin from '../../helpers/socket';

import {createHelpers} from 'vuex-map-fields';
import Reduction_description from "./info_block/reduction_description.vue";
import Reduction_info from "./info_block/reduction_info.vue";
import tender_files from "../contragent/tender/tabs/tender_files.vue";
import Reduction_users from "./comerc/reduction_users.vue";
import bind_reduction_positions from "./comerc/bind_reduction_positions.vue";
import positions from "./sale/positions.vue";
import Reduction_timer from "./info_block/reduction_timer.vue";
import timer from "../../../js_old/components/reduction/fields/timer.vue";

const {mapFields} = createHelpers({
    getterType: 'reduction/getReductionField',
    mutationType: 'reduction/updateReductionField',
});


export default {
    name: "reduction",
    components: {
        timer,
        Reduction_timer,
        positions, bind_reduction_positions, Reduction_users, tender_files, Reduction_info, Reduction_description},
    mixins: [socketMixin],
    props : {
        admin : {
            type : Boolean,
            default : false,
        },
        
        user_role : {
            type: String,
            required: true,
        },
        
        tender_id : {
            type : Number ,
            required: true
        },
        
        date: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isConnected : false,
            refreshTimer: null
        }
    },
    
    created() {
        IMC_CORE.showloading();
        EventBus.$on('make_bid', this.make_bid);
        
        this.startPolling();
    },
    
    mounted() {
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.$store.dispatch("reduction/GET_TENDER", this.tender_id);
            }
        });
    },
    
    beforeDestroy() {
        EventBus.$off('make_bid', this.make_bid);
        
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
        }
    },
    
    sockets: {
        
        error: function (data) {
            this.slog("socket error "+ data.toString());
            console.log(data);
            IMC_CORE.snackbar(data.message,'danger','Помилка');
        },
        
        connect_error: function (data) {
            this.slog("socket connect_error "+ data.toString());
            console.log(data);
        },
        
        reconnect_error: function (data) {
            this.slog("socket reconnect_error "+ data.toString());
            console.log(data);
        },
        
        connect_timeout: function (data) {
            this.slog("socket connect_timeout "+ data.toString());
            console.log(data);
        },
        
        connect() {
            this.isConnected = true;
            this.slog("server connected", 1);
            console.log("server connected");
        },
        
        connected: function (data) {
            this.$store.dispatch("reduction/GET_TENDER",this.tender_id);
        },
        
        disconnect: function (data) {
            this.isConnected = false;
            IMC_CORE.showloading();
        },
        
        SERV_READY: function (data) {
            let push = {
                name: 'CONNECT : ' + IMC_CORE_CONST.IP,
                CONST: IMC_CORE_CONST,
                attribute: {
                    doc_id: this.tender_id,
                    user_role: this.user_role,
                    user_id : IMC_CORE_CONST.user,
                }
            };
            console.log('push',push);
            this.$socket.emit('init', push);
        },
        
        refresh_users: function (data) {
            if (this.user_role === 'comerc') {
                this.$store.dispatch("reduction/GET_USERS", this.tender_id);
            }
        },
        
        make_lock_position: function (data) {
            this.make_lock_position(data);
        },
        
        make_unlock_position: function (data) {
            this.make_unlock_position(data);
        },
        
        make_refresh_position: function (data) {
            this.make_refresh_position(data);
        }
    },
    
    methods: {
        
        startPolling() {
            this.refreshTimer = setInterval(() => {
                if (this.isConnected) {
                    return;
                }
                this.$store.dispatch("reduction/GET_TENDER", this.tender_id);
            }, 3000);
        },
        
        forceTenderUpdate() {
            this.$store.dispatch("reduction/GET_TENDER", this.tender_id);
        },
        
        slog:function(data,sucsess = 0) {
            axios.post('/internal/api/slog', {
                'sucsess':sucsess,
                'log': data,
                'tender':this.tender_id,
                'user': IMC_CORE_CONST.user,
            });
        },
        
        make_bid:function(item) {
            console.log('make_bid', item, this.$socket)
            
            this.$socket.emit('lock_position', {
                bid_id: item.id,
                bid_step: item.cur_step,
                tender_id: this.tender_id,
                user_id: IMC_CORE_CONST.user
            });
            
            axios.post('/internal/reduction/make_bind', {
                'tender_id': this.tender_id,
                'bid_id': item.id,
                'bid_step': item.cur_step,
                'cur_price': item.cur_cost,
            }).then(({data}) => {
                if (data.status == 'operation_success') {
                    IMC_CORE.snackbar('Ставку прийнято');
                    this.$socket.emit('unlock_position', {
                        bid_id: item.id,
                        bid_step: item.cur_step,
                        tender_id: this.tender_id,
                        n_reload: true
                    });
                } else {
                    
                    EventBus.$emit('show_toast', {
                        err: data.status,
                        type: "danger",
                        title: data.data
                    });
                    this.$socket.emit('unlock_position', {
                        bid_id: item.id,
                        bid_step: item.cur_step,
                        tender_id: this.tender_id,
                        n_reload: false
                    });
                }
                
            })
                .catch(error => {
                    IMC_CORE.snackbar('Помилка');
                    console.log(error);
                });
        },
        
        make_unlock_position:function(item) {
            if (item.n_reload) {
                this.$store.dispatch("reduction/GET_TENDER", this.tender_id);
            } else {
                IMC_CORE.hideloading();
            }
        },
        
        make_refresh_position:function(item) {
            this.$store.dispatch("reduction/GET_TENDER",this.tender_id);
        },
        
        make_lock_position:function(item) {
            console.log('lock_position',item);
            IMC_CORE.showloading();
        },
        
    },
    
    computed: {
        ...mapFields([
            'reduction',
            'users'
        ]),
        
        is_admin: function () {
            return this.admin;
        },
        
        is_comerc: function () {
            return this.user_role === 'comerc';
        },
        
        loading:function () {
            /*if (this.isConnected) {
                IMC_CORE.showloading();
                console.log('cc')
            } else {
                IMC_CORE.hideloading();
                console.log('dd')
            }*/
            
            return this.isConnected;
        },
        
    },
    
}
</script>

<style scoped>

</style>